const systemSettings = {
  pageName: 'הגדרות מערכת',
  templatePlaceholder: 'בחר תבנית',
  templateLabel: 'תבנית הגדרות מערכת פעילה',
  templateDescriptions: 'בחר תבנית מהרשימה הנפתחת למעלה. התבנית שנבחרה תיושם כאשר תלחץ על "שמור".',
  switchButton: {
    label: 'תצוגה',
    options: {
      site: 'אתר',
      account: 'חשבון',
    },
  },
  toasts: {
    successfully: 'נשמר בהצלחה',
    error: 'שגיאה',
  },
  toastReset: {
    successfully: 'שחזור לברירת המחדל הושלם בהצלחה',
    error: 'השחזור לברירת המחדל נכשל',
  },
  modalDelete: {
    header: 'מחק תבנית',
    body: 'אתה עומד למחוק תבנית?',
  },
  modalUnsaved: {
    header: 'שינויים שלא נשמרו',
    body: 'השינויים שבוצעו לא נשמרו. האם ברצונך להמשיך ללא שמירתם?',
  },
  modalResetSettings: {
    header: 'שחזר הגדרות ברירת מחדל',
    body: 'בהמשך\nתחזור להגדרות ברירת המחדל\nמה שיגרום לאובדן כל ההתאמות שביצעת',
  },
  modalDeleteError: {
    header: 'מחיקת תבנית עם אוטומציה מופעלת',
    body: 'אתה עומד למחוק תבנית המקושרת לאוטומציות. כדי להמשיך במחיקה עליך לנתק אותה תחילה מהאוטומציות המשויכות.',
  }
};

export default systemSettings;
